import {
    View,
    Text,
    ScrollView,
    ActivityIndicator,
    TextInput,
    Linking,
    StyleSheet,
    TouchableOpacity
} from 'react-native'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { useEffect } from 'react'
import { useStoreStore } from '../../../stores/storeInfo'
import { Loading } from '../../shared/navigator/Loading'
import ScreenStatus from '../../home/ScreenStatus'

const PainformationTable = ({ navigation, route }) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        essFormKey,
        values
    } = params

    const { loading, postpaonline, getmodetails, getpapsdcodes, papsdcode, psdloading, error } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()
    const {
        storeData: storeData,
        error: errorStore,
        loading: storeLoading,
        fetchData,
        updateData
    } = useStoreStore()

    useEffect(() => {
        getmodetails(initializestore?.initializeData?.userkey)
        fetchData(userId)
        getpapsdcodes(initializestore?.initializeData?.userkey)
    }, [])
    if (psdloading) {
        return <Loading />
    }
    const total = Number(papsdcode?.workLst.replace(/[^0-9.-]+/g, "")) + Number(papsdcode?.workSchoolLst.replace(/[^0-9.-]+/g, ""));
    const hometotal =
        Number(papsdcode?.homeSchoolResidentEit?.replace(/[^0-9.-]+/g, "")) +
        Number(papsdcode?.homeResidentEit?.replace(/[^0-9.-]+/g, ""));

    function checkValuesEdited() {
        // If values is not defined, return default object
        if (!values || typeof values !== 'object') {
            return {
                residentpsdcode: papsdcode?.homePsdCode || '',
                municipality: papsdcode?.homeLocation,
                county: papsdcode?.homeCounty,
                totalresidenteitrate: hometotal
            };
        }

        // If values exists, just return it as is
        return values;
    }

    const handleConfirm = async () => {
        const currentValues = checkValuesEdited()

        const municipality = String(currentValues?.municipality || '').trim()
        const county = String(currentValues?.county || '').trim()
        const residentpsdcode = String(currentValues?.residentpsdcode || '').trim()
        const totalresidenteitrate = String(currentValues?.totalresidenteitrate ?? '').trim()

        if (
            !municipality ||
            !county ||
            !residentpsdcode ||
            !totalresidenteitrate ||
            totalresidenteitrate.toLowerCase() === 'nan' ||
            isNaN(Number(totalresidenteitrate)) ||
            isNaN(Number(residentpsdcode))
        ) {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: 'Cannot submit form. Required tax details are missing.',
                visibilityTime: 5000,
                autoHide: true,
                topOffset: 60
            })
            return
        }

        const data = {
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            essObKey: essUserOnBoardingKey,
            completeOnline: mode === 'upload' ? false : true,
            essUserKey: initializestore?.initializeData?.userkey,
            entityId: personalstore?.personalData?.entityId,
            municipality: municipality,
            county: county,
            residentPsdcode: Number(residentpsdcode),
            totalResdientEitrate: Number(totalresidenteitrate),
            WorkLocationPsdcode: papsdcode?.workPsdCode,
            WorkCounty: papsdcode?.workCounty,
            WorkMunicipality: papsdcode?.workLocation,
            totalNonResdientEitrate: Number(papsdcode?.workNonResidentEit?.replace(/[^0-9.-]+/g, "") || 0)
        }

        const response = await postpaonline(data)
        if (response?.success) {
            if (mode === 'online') {
                navigation.navigate('Paonline', {
                    userId,
                    mode,
                    essUserOnBoardingKey,
                    essUserOnBoardingFormKey,
                    essFormKey,
                    values: currentValues
                })
            } else {
                await Toast.show({
                    type: 'success',
                    position: 'bottom',
                    text1: response?.message,
                    visibilityTime: 3000,
                    autoHide: true,
                    topOffset: 60,
                    onHide: () => {
                        navigation.replace('OnboardingForms')
                    }
                })
            }
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    if (error || errorStore) return <ScreenStatus message={error || errorStore} />

    return (
        <ScrollView>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'PA Withholding Taxation '}
                    />
                </View>
            </View>
            <Card>
                <View style={{ flex: 1, borderWidth: 2, borderColor: "#989898" }}>
                    <View style={{
                        backgroundColor:
                            "#add8e6"
                    }}>
                        <Text style={styles.title}>
                            Your Local Withholding Tax Rates{' '}
                            {/* <Text style={styles.subText}> (as of 11/7/2025)</Text> */}
                        </Text>
                    </View>
                    <View style={{ width: "100%", marginTop: 20, }}>
                        <View style={{ width: "100%", flexDirection: 'row', backgroundColor: "#dcdcdc" }}>
                            <View style={{ width: "30%", borderWidth: 1, padding: 3, borderColor: "#d2d2d2" }}>
                                <Text style={{ fontWeight: "bold" }}>HOME: {papsdcode?.homeCounty}</Text>
                            </View>
                            <View style={{ width: "70%", borderWidth: 1, padding: 3, borderColor: "#d2d2d2" }}>
                                <Text style={{ fontWeight: "bold" }}>{personalstore?.personalData?.addressLine1}, {personalstore?.personalData?.city}, {personalstore?.personalData?.stateValue == 'PA' ? "Pennsylvania" : ""}, {personalstore?.personalData?.zip}</Text>
                            </View>

                        </View>
                        <View style={{ width: "100%", flexDirection: 'row', backgroundColor: '#add8e6' }}>
                            <View style={{ width: "30%", borderWidth: 1, padding: 7, borderColor: "#abc8d1" }}>
                                <Text style={{ textAlign: 'center', fontWeight: "bold", }}>LOCATION</Text>
                            </View>
                            <View style={{ width: "12%", borderWidth: 1, padding: 7, borderColor: "#abc8d1" }}>
                                <Text style={{ fontWeight: "bold" }}>PSD Code</Text>
                            </View>
                            <View style={{ width: "13%", borderWidth: 1, padding: 7, borderColor: "#abc8d1" }}>
                                <Text style={{ fontWeight: "bold" }}>Resident EIT</Text>
                            </View>
                            <View style={{ width: "18%", borderWidth: 1, padding: 7, borderColor: "#abc8d1" }}>
                                <Text ></Text>
                            </View>
                            <View style={{ width: "7%", borderWidth: 1, padding: 7, borderColor: "#abc8d1" }}>
                                <Text></Text>
                            </View>
                            <View style={{ width: "20%", borderWidth: 1, padding: 7, borderColor: "#abc8d1" }}>
                                <Text></Text>
                            </View>

                        </View>
                        <View style={{ width: "100%", flexDirection: 'row', backgroundColor: "#dcdcdc" }}>
                            <View style={{ width: "30%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}>{values?.municipality ? values?.municipality : papsdcode?.homeLocation}</Text>
                            </View>
                            <View style={{ width: "12%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}>{papsdcode?.homePsdCode}</Text>
                            </View>
                            <View style={{ width: "13%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}>{papsdcode?.homeResidentEit}</Text>
                            </View>
                            <View style={{ width: "18%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text></Text>
                            </View>
                            <View style={{ width: "7%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text></Text>
                            </View>
                            <View style={{ width: "20%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text></Text>
                            </View>

                        </View>
                        <View style={{ width: "100%", flexDirection: 'row', backgroundColor: "#dcdcdc" }}>
                            <View style={{ width: "30%", borderWidth: 1, borderColor: "#c5c5c5", padding: 7 }}>
                                <Text style={{ fontWeight: "bold" }}>{values?.county ? values?.county : papsdcode?.homeSchoolLocation}</Text>
                            </View>
                            <View style={{ width: "12%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}>{papsdcode?.homeSchoolPsdCode}</Text>
                            </View>
                            <View style={{ width: "13%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}>{papsdcode?.homeSchoolResidentEit}</Text>
                            </View>
                            <View style={{ width: "18%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text></Text>
                            </View>
                            <View style={{ width: "7%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text></Text>
                            </View>
                            <View style={{ width: "20%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text></Text>
                            </View>

                        </View>
                    </View>

                    <View style={{ width: "100%", marginTop: 20, }}>
                        <View style={{ width: "100%", flexDirection: 'row', backgroundColor: "#dcdcdc" }}>
                            <View style={{ width: "30%", borderWidth: 1, padding: 3, borderColor: "#d2d2d2" }}>
                                <Text style={{ fontWeight: "bold" }}>WORK: {papsdcode?.workCounty}</Text>
                            </View>
                            <View style={{ width: "70%", borderWidth: 1, padding: 3, borderColor: "#d2d2d2" }}>
                                <Text style={{ fontWeight: "bold" }}>{storeData?.storeAdress1}, {storeData?.storeCity}, {storeData?.storeState == 'PA' ? "Pennsylvania" : ""}, {storeData?.storeZipCode}</Text>
                            </View>

                        </View>
                        <View style={{ width: "100%", flexDirection: 'row', backgroundColor: '#add8e6' }}>
                            <View style={{ width: "30%", borderWidth: 1, padding: 7, borderColor: "#abc8d1" }}>
                                <Text style={{ textAlign: 'center', fontWeight: "bold", }}>LOCATION</Text>
                            </View>
                            <View style={{ width: "12%", borderWidth: 1, padding: 7, borderColor: "#abc8d1" }}>
                                <Text style={{ fontWeight: "bold" }}>PSD Code</Text>
                            </View>
                            <View style={{ width: "13%", borderWidth: 1, padding: 7, borderColor: "#abc8d1" }}>
                                <Text style={{ fontWeight: "bold" }}></Text>
                            </View>
                            <View style={{ width: "18%", borderWidth: 1, padding: 7, borderColor: "#abc8d1" }}>
                                <Text style={{ fontWeight: "bold" }}>Non Resident EIT</Text>
                            </View>
                            <View style={{ width: "7%", borderWidth: 1, padding: 7, borderColor: "#abc8d1" }}>
                                <Text style={{ fontWeight: "bold" }}>LST</Text>
                            </View>
                            <View style={{ width: "20%", borderWidth: 1, padding: 7, borderColor: "#abc8d1" }}>
                                <Text style={{ fontWeight: "bold" }}>LST Low Income Exemptions</Text>
                            </View>

                        </View>
                        <View style={{ width: "100%", flexDirection: 'row', backgroundColor: "#dcdcdc" }}>
                            <View style={{ width: "30%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}>{papsdcode?.workLocation}</Text>
                            </View>
                            <View style={{ width: "12%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}>{papsdcode?.workPsdCode}</Text>
                            </View>
                            <View style={{ width: "13%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>

                            </View>
                            <View style={{ width: "18%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}>{papsdcode?.workNonResidentEit}</Text>
                            </View>
                            <View style={{ width: "7%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}>{papsdcode?.workLst}</Text>
                            </View>
                            <View style={{ width: "20%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}>{papsdcode?.workLstLowIncomeExemptions}</Text>
                            </View>

                        </View>
                        <View style={{ width: "100%", flexDirection: 'row', backgroundColor: "#dcdcdc" }}>
                            <View style={{ width: "30%", borderWidth: 1, borderColor: "#c5c5c5", padding: 7 }}>
                                <Text style={{ fontWeight: "bold" }}>{papsdcode?.workSchoolLocation}</Text>
                            </View>
                            <View style={{ width: "12%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}>{papsdcode?.workSchoolPsdCode}</Text>
                            </View>
                            <View style={{ width: "13%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>

                            </View>
                            <View style={{ width: "18%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}></Text>
                            </View>
                            <View style={{ width: "7%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}>{papsdcode?.workSchoolLst}</Text>
                            </View>
                            <View style={{ width: "20%", borderWidth: 1, padding: 7, borderColor: "#c5c5c5", }}>
                                <Text style={{ fontWeight: "bold" }}>{papsdcode?.workSchoolLstLowIncomeExemptions}</Text>
                            </View>

                        </View>
                    </View>

                    <View style={{ maxWidth: 400, borderWidth: 1, marginHorizontal: "auto", marginVertical: 40, width: '90%' }}>
                        <View style={{ width: "100%", backgroundColor: "#add8e6", borderWidth: 1, borderColor: "#a8c3cc" }}>
                            <Text style={styles.title}>Total Taxes to be Withheld</Text>
                        </View>

                        <View style={{ flexDirection: 'row' }}>
                            <View
                                style={{
                                    flex: 0.45,
                                    padding: 5,
                                    borderWidth: 1,
                                    borderColor: '#d9d7d2',
                                    backgroundColor: '#fffacd',
                                    margin: 2,
                                }}
                            >
                                <Text>EIT</Text>
                            </View>
                            <View
                                style={{
                                    flex: 0.55,
                                    padding: 5,
                                    borderWidth: 1,
                                    borderColor: '#d9d7d2',
                                    backgroundColor: '#fffacd',
                                    margin: 2,
                                }}
                            >
                                <Text>{values?.totalresidenteitrate ? values?.totalresidenteitrate : hometotal?.toFixed(3)} % </Text>
                            </View>
                        </View>

                        <View style={{ flexDirection: 'row' }}>
                            <View
                                style={{
                                    flex: 0.45,
                                    padding: 5,
                                    borderWidth: 1,
                                    borderColor: '#d9d7d2',
                                    backgroundColor: '#fffacd',
                                    margin: 2,
                                }}
                            >
                                <Text>LST</Text>
                            </View>
                            <View
                                style={{
                                    flex: 0.55,
                                    padding: 5,
                                    borderWidth: 1,
                                    borderColor: '#d9d7d2',
                                    backgroundColor: '#fffacd',
                                    margin: 2,
                                }}
                            >
                                <Text>${total}</Text>
                            </View>
                        </View>

                    </View>




                </View>
                <TouchableOpacity style={{ marginVertical: 10 }} onPress={() => navigation.navigate("PainformationForm", {
                    essUserOnBoardingFormKey,
                    essUserOnBoardingKey,
                    essFormKey,
                    mode: 'online', values
                })}>
                    <Text style={{ color: "red", textDecorationLine: "underline", textAlign: "center", fontSize: 18 }}>Click here to return to the main menu to make any corrections.</Text>
                </TouchableOpacity>

                {loading ? (
                    <ActivityIndicator style={{ marginVertical: 10 }} />
                ) : (
                    <View style={{ marginVertical: 10 }}>
                        <CustomButton
                            text={'I confirm the information above is correct'}
                            onPress={handleConfirm}
                        />
                    </View>
                )}
            </Card>
        </ScrollView >

    )
}

export default PainformationTable;
const styles = StyleSheet.create({
    title: {
        fontWeight: 'bold',
        textAlign: 'center',
        fontSize: 20,
    },
    subText: {
        fontSize: 10,
        fontWeight: 'bold',
    },
})
